<template>
  <div class="project-description-tab">
    <div class="header">
      <div class="header-title">Decription</div>
      <div class="actions-bar">
        <button
          v-if="!editMode"
          class="btn-rounded edit-button"
          @click="() => toggleEdit()"
        >
          <div class="edit-icon"></div>{{ $t("edit") }}
        </button>
        <div class="edit-mode-options" v-else>
          <button
            :disabled="saving"
            class="btn btn--primary save-button"
            @click="() => cancelEdit()"
          >
            {{ $t("Cancel") }}
          </button>
          <button
            class="btn btn--primary save-button"
            :disabled="saving"
            @click="() => saveChanges()"
          >
            {{saving ? $t("saving") : $t("save") }}
          </button>
        </div>
      </div>
    </div>
    <div class="description-container" :class="{'edit': editMode}" v-if="mergedProjectData">
      <input-container
        v-for="(field,i) in mergedProjectData.fields"
        ref="input"
        :key="field.name"
        v-model="mergedProjectData.fields[i]"
        @change="onInputChange"
        :readOnly="!editMode"
        class="project-description-item"
      />
    </div>
    <loading-overlay v-if="isLoading"></loading-overlay>
  </div>
</template>

<script>
import InputContainer from '@/components/inputs/InputContainer'
// import {mergeConfigData} from '@/utils/ConfigUtils'
import projectData from '@/mixins/projectData'
import Api from '@/api'

export default {
  name: 'ProjectDescription',
  props: ['project'],
  mixins: [projectData],
  components: {
    InputContainer
  },
  data () {
    return {
      editMode: false,
      saving: false,
    }
  },
  computed: {
    isLoading () {
      return !this.projectFields
    }
  },
  methods: {
    onInputChange (val) {
    },
    toggleEdit () {
      //this.$router.push({query: {...this.$route.query, editMode: !this.editMode}})
      this.editMode = !this.editMode
      if (this.editMode) {
        this.orginalFields = JSON.parse(JSON.stringify(this.mergedProjectData.fields))
      }
    },
    cancelEdit () {
      if(this.orginalFields){
        this.project.fields = JSON.parse(JSON.stringify(this.orginalFields))
      }
      this.editMode = false
    },
    saveChanges () {
      // TODO ADD SAVE and POST DATA
      // this.$refs.input.forEach((inp)=>{
      //   console.log(inp.getValue())
      // })
      // console.log(this.mergedProjectData)
      this.saving = true
      Api.putProject(this.mergedProjectData).then(resp => {
        this.saving = false
        this.toggleEdit()
      }).catch(err => {
        console.log(err)
        this.saving = false
      })
    }
  },
  beforeDestroy() {
    //petaba cuando no habia this.editor...
    this.editor && this.editor.destroy()
  }
}
</script>

<style lang="stylus" scoped>
.project-description-tab
  margin-top 10px
  overflow hidden
  display flex
  flex-direction column
  max-height calc(100vh - 300px)
  .header
    display flex
    border-bottom 1px solid $mystic
    align-items center
    margin-bottom 15px
    padding-bottom 15px


    .header-title
      m-font-size(18,30)
      color: $charade
      font-weight $fw-bold
    .actions-bar
      margin-left auto
      align-items: center
      display: flex
      margin-top 5px
      margin-right 10px

    .edit-button
      margin-left: auto

      .edit-icon
        m-icon("edit", 15)
        margin-right 5px

    .edit-mode-options
      align-items: center
      display: flex
      margin-left: auto

      .close-icon
        cursor: pointer
        m-icon("cross", 15)
        margin-right: 20px

  .description-container
    max-height calc(100% - 50px)
    overflow-y: scroll
    &.edit
      background: none
      padding: 0
</style>

<style lang="stylus">
.project-description-tab
  .project-description-item
    margin-bottom: 20px
    .input-component
      .text-input
        input
          width 50%
  .value-input-component-container
    .input-component
      padding 0 !important
      font-weight $fw-light
      label
        color #515662
        m-font-size(14,28)
        font-weight $fw-semi-bold
</style>
